export class WallSpriteRenderer {
    constructor(wallSprite, wallSXY, // wall spritesheet x + y
    wallSSize, // wall sprite size
    wallPos, // position to place wall
    wallSize, // wall destination size
    cornerSprite, cornerSXY, // corn er spritesheet x + y
    cornerPos) {
        /* Initialize wall variables */
        this.wallSprite = wallSprite;
        this.wallSXY = wallSXY;
        this.wallSSize = wallSSize;
        this.wallPos = wallPos;
        this.wallSize = wallSize;
        /* Initialize corner variables (if applicable) */
        this.cornerSprite = cornerSprite !== null && cornerSprite !== void 0 ? cornerSprite : null;
        this.cornerSXY = cornerSXY !== null && cornerSXY !== void 0 ? cornerSXY : null;
        this.cornerPos = cornerPos !== null && cornerPos !== void 0 ? cornerPos : null;
    }
    draw(context) {
        context.ctx.drawImage(this.wallSprite, this.wallSXY.x, this.wallSXY.y, this.wallSSize.getWidth(), this.wallSSize.getHeight(), this.wallPos.x, this.wallPos.y, this.wallSize.getWidth(), this.wallSize.getHeight());
        if (this.cornerSprite && this.cornerSXY && this.cornerPos) {
            context.ctx.drawImage(this.cornerSprite, this.cornerSXY.x, this.cornerSXY.y, 5, 5, this.cornerPos.x, this.cornerPos.y, 5 * this.wallSize.getScale(), 5 * this.wallSize.getScale());
        }
    }
}
